import getApiConfig from '../config/apiConfig';
import { logAPIError } from '../utils/apiErrorLogger';

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText);
  }
  return response.json();
};

const dashboardService = {
  // Get dashboard counts
  async getDashboardCounts() {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/admin/counts`);
      return handleResponse(response);
    } catch (error) {
      logAPIError('dashboardService', 'getDashboardCounts', 'GET', error);
      throw error;
    }
  },

  // Get won deals by Line of Business for pie chart
  async getWonDealsByLOB(startDate = null, endDate = null) {
    try {
      const { apiBaseUrl } = getApiConfig();
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      
      const response = await fetch(`${apiBaseUrl}/admin/charts/won-deals-by-lob?${params.toString()}`);
      return handleResponse(response);
    } catch (error) {
      logAPIError('dashboardService', 'getWonDealsByLOB', 'GET', error, { startDate, endDate });
      throw error;
    }
  },

  // Get opportunities by month for line chart
  async getOpportunitiesByMonth(monthsForward = 6, stages = 'Backlog,Lead,Qualified,Proposed') {
    try {
      const { apiBaseUrl } = getApiConfig();
      const params = new URLSearchParams();
      params.append('monthsForward', monthsForward.toString());
      params.append('stages', stages);
      
      const response = await fetch(`${apiBaseUrl}/admin/charts/opportunities-by-month?${params.toString()}`);
      return handleResponse(response);
    } catch (error) {
      logAPIError('dashboardService', 'getOpportunitiesByMonth', 'GET', error, { monthsForward, stages });
      throw error;
    }
  },

  // Get top customers by value
  async getTopCustomers(startDate = null, endDate = null) {
    try {
      const { apiBaseUrl } = getApiConfig();
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      
      const response = await fetch(`${apiBaseUrl}/admin/charts/top-customers?${params.toString()}`);
      return handleResponse(response);
    } catch (error) {
      logAPIError('dashboardService', 'getTopCustomers', 'GET', error, { startDate, endDate });
      throw error;
    }
  }
};

export default dashboardService; 